/**
 * @packageDocumentation
 * @module api.functional.admin.companies.prefix_available
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { ServiceResponseRecordstringboolean } from "../../../../structures/ServiceResponseRecordstringboolean";

/**
 * @controller CompanyController.isPrefixAvailable
 * @path GET /admin/companies/prefix-available/:prefix
 * @accessor api.functional.admin.companies.prefix_available.isPrefixAvailable
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function isPrefixAvailable(
  connection: IConnection,
  prefix: string,
): Promise<isPrefixAvailable.Output> {
  return PlainFetcher.fetch(connection, {
    ...isPrefixAvailable.METADATA,
    template: isPrefixAvailable.METADATA.path,
    path: isPrefixAvailable.path(prefix),
  });
}
export namespace isPrefixAvailable {
  export type Output = ServiceResponseRecordstringboolean;

  export const METADATA = {
    method: "GET",
    path: "/admin/companies/prefix-available/:prefix",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (prefix: string) =>
    `/admin/companies/prefix-available/${encodeURIComponent(prefix?.toString() ?? "null")}`;
}
